// extracted by mini-css-extract-plugin
export default {"inputName":"InputName_inputName__Yr1f4","inputLabel":"InputName_inputLabel__MPMlr","inputError":"InputName_inputError__0VeoK"};